module.exports = __webpack_public_path__ + "img/50f8c0b1e03f39b6e3a9667226a88668.png";